import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Entry } from 'contentful';
import { Observable, Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { AuthService } from '../../services/auth/auth.service';
import { LocalizationService } from '../../services/localization/localization.service';
import { StoreService } from '../../services/store/store.service';
import { TestResultService } from '../../services/test-result/test-result.service';
import { first } from 'rxjs/operators';

const monthlyMultiplier = 0.002333; // pricePerCarbonDioxideTon 28€

@Component({
  selector: 'app-choose-plan',
  templateUrl: './choose-plan.component.html',
  styleUrls: ['./choose-plan.component.scss'],
})
export class ChoosePlanComponent implements OnInit {
  @Input() public content: Entry<any>;
  @Input() public hasSubscription = false;
  public plans: Array<any>;
  public isLoggedIn$ = this.authService.isLoggedIn();
  public currentLocale$: Observable<string | undefined>;
  public testResult$: Observable<any>;

  constructor(
    private localizationService: LocalizationService,
    private authService: AuthService,
    private store: StoreService,
    private analyticsService: AnalyticsService,
    private testResultService: TestResultService,
  ) {
    this.plans = Object.values(environment.stripe.plans);
  }

  ngOnInit() {
    this.currentLocale$ = this.localizationService.locale;
    this.testResult$ = this.testResultService.getTestResult();
  }

  getPlanName(planKey: string, locale: string) {
    return this.plans[planKey].name[locale];
  }

  pricePerDay(plan, co2e) {
    return (this.pricePerMonth(plan, co2e) * 12) / 365;
  }

  pricePerMonth(plan, co2e) {
    return Math.round(co2e * monthlyMultiplier) * plan.pricePerQuantity;
  }

  async selectPlan(plan, testResult): Promise<void> {
    const co2e = testResult.co2e;

    this.store.selectedPlan.next(plan);
    this.store.selectedPlanQuantity.next(Math.round(co2e * monthlyMultiplier));
    this.store.selectedPlanCo2e.next(co2e);
    this.store.selectedPlanDay.next(this.pricePerDay(plan, co2e));
    this.store.selectedPlanTotal.next(this.pricePerMonth(plan, co2e));
    this.analyticsService.selectPlan(plan.key, this.pricePerMonth(plan, co2e));
    this.localizationService.navigate(['checkout', 'pay']);
  }

  registerOnly() {
    this.localizationService.goToJoin();
  }
}
